import React from 'react';
import { Button } from '../ui/button';
import { Sparkles, Phone, CheckCircle, Clock } from 'lucide-react';

const HomeCTA = ({ onBookCall }) => (
  <section className="py-16 bg-gradient-to-br from-gray-900 to-gray-800 text-white">
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
      <Sparkles className="w-16 h-16 mx-auto mb-6 text-[#FDB913]" />
      <h2 className="text-3xl md:text-4xl font-bold mb-6">Ready to Start Your Wine Journey?</h2>
      <p className="text-xl mb-8 opacity-90">
        Book a free consultation call with our wine experts. We'll help you choose the perfect wine and guide you through every step.
      </p>
      <Button
        size="lg"
        onClick={onBookCall}
        data-track="book_call:home_cta_book_call"
        className="bg-[#FDB913] hover:bg-[#E5A50A] text-gray-900 font-semibold text-lg px-8 py-6"
      >
        <Phone className="w-5 h-5 mr-2" />
        Schedule Your Call Now
      </Button>
      <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-6 text-sm">
        <div className="flex items-center gap-2">
          <CheckCircle className="w-5 h-5 text-[#FDB913]" />
          <span>Free Consultation</span>
        </div>
        <div className="flex items-center gap-2">
          <Clock className="w-5 h-5 text-[#FDB913]" />
          <span>15-30 Minutes</span>
        </div>
        <div className="flex items-center gap-2">
          <CheckCircle className="w-5 h-5 text-[#FDB913]" />
          <span>No Obligation</span>
        </div>
      </div>
    </div>
  </section>
);

export default HomeCTA;
